import { apiRequest } from "@core/services/api/apiRequest";
import type { NewsPage } from "./news.types";

/**
 * A page of published posts.
 *
 * Kept apart from the components so that asking whether any posts exist costs
 * nothing but this file: the components draw themselves with the marketing
 * feature's sections and type, and reaching them from the marketing feature
 * in turn would close a circle around both.
 */
export const newsPageQuery = (page: number, pageSize: number) => ({
  queryKey: ["newsPosts", pageSize, page],
  queryFn: () =>
    apiRequest(`/blog/?page=${page}&page_size=${pageSize}`, "GET", undefined, false) as Promise<NewsPage>,
  staleTime: 5 * 60 * 1000,
});
